<form 
  [formGroup]="paymentForm" 
  (ngSubmit)="submitPayment()" 
  class="space-y-5 bg-white p-4 sm:p-6 rounded-2xl shadow-lg w-full max-w-md mx-auto border border-gray-200"
>

  <!-- Email -->
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
    <input 
      type="email" 
      formControlName="email" 
      placeholder="customer@example.com"
      class="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition text-sm sm:text-base"
    />
  </div>

  <!-- Card Number -->
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Card Number</label>
    <div id="card-number-element" class="stripe-input"></div>
  </div>

  <!-- Expiry & CVC -->
  <div class="grid grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">Expiry</label>
      <div id="card-expiry-element" class="stripe-input"></div>
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">CVC</label>
      <div id="card-cvc-element" class="stripe-input"></div>
    </div>
  </div>

  <!-- Postal Code (native Angular input) -->
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Postal Code</label>
    <input 
      type="text" 
      formControlName="postalCode"
      placeholder="12345"
      class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition text-sm sm:text-base"
    />
  </div>

  <!-- Submit Button -->
  <button mat-flat-button color="primary" type="submit" [disabled]="paymentProcessing" class="w-full text-sm sm:text-base py-2"> 
    {{ paymentProcessing ? 'Processing...' : 'Confirm Payment' }} 
  </button>
</form>
